// import { Link } from '@tanstack/react-router';
// import { routes } from '@/routes/routes';

import { ArticleContent } from '@/components/layout/ArticleContent';

export const TermsAndConditionsPage = () => {
  return (
    <ArticleContent>
      <h1>EternaLife Terms & Conditions</h1>
      <p>Last Updated: Martch 29 th, 2024</p>
      <h2>1. WEBSITE & DELIVERY TERMS AND CONDITIONS</h2>
      <h3>EternaLife.co.uk</h3>
      <p>
        <b>a)</b> EternaLife Limited is the controller of and responsible for
        this website (collectively referred to as ”EternaLife”, “we”, “us” or
        “our” in these Terms and Conditions).
      </p>
      <p>
        <b>b)</b> “EternaLife” is the trademark or registered trademark of
        EternaLife Limited and/or our affiliates in the U.K. and in other
        countries.
      </p>
      <p>
        <b>c)</b> The material on the Web Site is copyright to EternaLife
        Limited or our content and technology providers. You are welcome to
        view, print and download the contents of the Web Site for personal use,
        but not for any commercial purposes or re-publication.
      </p>
      <h2>2. Contacting Us</h2>
      <p>
        <b>a)</b> Our contact address is: 85 Great Portland Street, First Floor,
        London, England. You may also email us at info@eternalife.co.uk.{' '}
      </p>
      <h2>3. Web Site Information</h2>
      <p>
        <b>a)</b> We have tried to ensure that information provided on the Web
        Site is accurate. However, we make no representation and give no
        warranty of any kind in respect of the information.
      </p>
      <p>
        <b>b)</b> We do not accept liability for any loss (direct, indirect or
        consequential) which may arise from reliance on information contained in
        the Web Site or in respect of any error or omission, except in relation
        to death or personal injury caused by our negligence.{' '}
      </p>
      <h2>4. Description of Products and Services</h2>
      <p>
        <b>a)</b> ‘Products’ shall mean the products listed on the Web Site
        and/or products supplied by third parties
      </p>
      <p>
        <b>b)</b> ‘Services’ shall mean the services we provide in connection
        with each products’ order and shall include assembling a set of products
        based on the recommendations provided by your healthcare specialist or
        treatment facility and your clinical needs, purchasing this set of
        products on your behalf, and preparing the products for consumption by
        dividing and packaging them into individual portions as well as ensuring
        the assembly and delivery of automatic refills and altering your product
        and service subscription in accordance with your updated test results
      </p>
      <p>
        <b>c)</b> The description and specification of products and services in
        the Web Site is only approximate and we reserve the right to make
        changes which do not materially affect the quality or performance of
        those products or quality of the services.
      </p>
      <p>
        <b>d)</b> We may correct any error appearing in the Web Site or withdraw
        any product or service from sale without incurring liability. Price
        (prior to the placement of an order) and availability are also subject
        to change without notice.
      </p>
      <h2>5. Signing up</h2>
      <p>
        <b>a)</b> Registration is permitted solely upon the recommendation or
        direction of your healthcare specialist or treatment facility. We retain
        the right to decline account creation, product supply, and service
        provision, as well as to delete your account if you sign up without the
        explicit direction of a healthcare specialist or treatment facility{' '}
      </p>
      <p>
        <b>b)</b> Upon signup you will have to provide your personal data,
        including your identity data and contact data, and we will receive your
        personal data, including your health data and genetic information, from
        your healthcare specialist or treatment facility. Your personal data
        will be processed in accordance with our{' '}
        {/* TODO: Privacy Policy link - route not yet implemented in Router.tsx */}
        {/* <Link to={routes.legal.privacyPolicy}>Privacy Policy</Link> */}
        Privacy Policy
      </p>
      <h2>6. Ordering Products and Services</h2>
      <p>
        <b>a)</b> You may order products and services from the Web Site by
        signing up and either picking a ready-made set of products and services
        tailored to your needs or completing a custom order form:
        <ul>
          <li>
            <b>i)</b> Ready-made sets of products and services are prepared in
            accordance with the data received from your healthcare specialist or
            treatment facility and your clinical needs
          </li>
          <li>
            <b>ii)</b> By completing a custom order form, you authorize us to
            assemble a set of products based on the recommendations provided by
            your healthcare specialist or treatment facility and your clinical
            needs
          </li>
        </ul>
        For more details on the processing of your personal data, including your
        health data and genetic information, please refer to our{' '}
        {/* TODO: Privacy Policy link - route not yet implemented in Router.tsx */}
        {/* <Link to={routes.legal.privacyPolicy}>Privacy Policy</Link> */}
        Privacy Policy
      </p>
      <p>
        <b>b)</b> After you select a ready-made set of products and services or
        submit a custom order form, we will present you with an offer for
        products and services
      </p>
      <p>
        <b>c)</b> After receiving our offer for products and services, you have
        a right to customize your order by adding or removing products. Please
        note that by doing so you assume responsibility for ensuring the
        suitability of the products for your specific clinical needs
      </p>
      <p>
        <b>d)</b> Once you confirm your order, we will accept it and send an
        order confirmation to the e-mail address you have given and the sending
        of this e-mail (whether or not it is received) makes the contract
        between us. After confirming your order, we will purchase the products
        on your behalf, prepare the products for consumption by dividing and
        packaging them into individual portions and arrange their delivery to
        you
      </p>
      <p>
        <b>e)</b> Products and services cannot be ordered separately
      </p>
      <p>
        <b>f)</b> Under your express consent we will ensure the assembly and
        delivery of automatic product refills
      </p>
      <p>
        <b>g)</b> You can give consent for us to change your subscription by
        your recuring product and service orders in accordance with your updated
        test results.
      </p>
      <h2>7. The Price and Payment</h2>
      <p>
        <b>a)</b> The price of the products and services will be the price
        quoted in the Web Site at the time we accept your order. The price will
        mention and include any value added tax, but not the cost of delivery.
      </p>
      <p>
        <b>b)</b> In addition to the product and service price, you will have to
        pay our delivery charges as quoted on the Web Site at the time we accept
        your order – unless you qualify for free delivery. The amount of these
        charges varies according to the method of delivery and the delivery
        address you specify in your order.
      </p>
      <p>
        <b>c)</b> Payment is made by credit card or payment gateway at the time
        we accept your order (the payment methods we accept are listed on the
        Web Site at the time you place your order). Refunds will generally be
        made by means of a credit to your original payment method.
      </p>
      <p>
        <b>d)</b> Although every care is taken in the quality of content on this
        site, there may occasionally be an error and items and services may be
        mis-priced. In this event we will either: contact you to ask if you wish
        to cancel the order, or simply cancel the order and notify you, at our
        own discretion. We are under no obligation to supply goods and services
        at the incorrect price.
      </p>
      <h2>8. Delivery of Products</h2>
      <p>
        <b>a)</b> We will arrange for delivery of the products you order by the
        method and to the address which you specify in the check-out procedure.
        We use third party service providers for deliveries.
      </p>
      <p>
        <b>b)</b> If you do not take delivery of the products or supply adequate
        delivery instructions, we may cancel your order and retain the products.
        In this event, we will refund you the price of the products, but you
        will still be liable to pay any delivery charges.
      </p>
      <p>
        <b>c)</b> If there is an error or any other delivery problem in respect
        of your order, you must notify us in writing within 14 calendar days
        after the delivery date. We will not be liable for any loss or damage if
        you fail to do this.
      </p>
      <h2>9. General</h2>
      <p>
        <b>a)</b> The products and services advertised on the Web Site are
        intended for sale to persons dealing as consumers and are not for
        re-sale.
      </p>
      <p>
        <b>b)</b> The Contracts (Rights of Third Parties) Act 1999 shall not
        apply to any contract between us, so that no contractual rights are
        conferred on third parties.
      </p>
      <p>
        <b>c)</b> Any contract between us shall incorporate these terms and
        conditions and be under English law. If there is any dispute, the
        English Courts will have exclusive jurisdiction.
      </p>
      <p>
        <b>d)</b> EternaLife Products are food supplements and they have not
        been evaluated by the MHRA. Food supplements are intended to correct
        nutritional deficiencies, maintain an adequate intake of certain
        nutrients, or to support specific physiological functions. They are not
        medicinal products and as such cannot exert a pharmacological,
        immunological or metabolic action. Therefore, their use is not intended
        to treat or prevent diseases in humans or to modify physiological
        functions.
      </p>
      <p>
        <b>e)</b> The material on this website is provided for informational
        purposes only and is not medical advice. In case of any questions
        related to your health, please contact your health care professional.
      </p>
      <p>
        <b>f)</b> EternaLife Products should be consumed in accordance with the
        recommendations of your health care professional.
      </p>
      <h2>10. Subscribe & Save</h2>
      <p>
        <b>Subscribe & Save Terms & Conditions</b>
      </p>
      <p>
        Subscribe & Save is a subscription service offered by EternaLife.
        EternaLife reserves the right to change the repeat order benefits, the
        discount amount and free delivery offer at any time. Subscribe & Save
        items will ship automatically based on the frequency you select until
        you cancel. By placing your order, you are authorising us to charge your
        card for future orders at the frequency you have selected.
      </p>
      <p>
        You can change the frequency or cancel your subscriptions at any time
        through the My Subscriptions section which can be found in My Account.
        On all subscription orders you will qualify for the best product and
        service price and free standard delivery. The best price is calculated
        based on the lowest price available in the 90 days prior to the date
        your order places. If you subscribe to 1-2 items in one subscription
        order, you’ll receive a 5% discount. For 3-4 items, you’ll receive 10%
        off. For 5+ items, you’ll receive 15% off. Please note, your first order
        is excluded from the exclusive discount, but it will be applied on all
        subsequent subscription orders.
      </p>
      <p>
        Free delivery is available on subsequent subscription orders, regardless
        of the order value.
      </p>
      <p>
        <b>Eligible Purchases</b>
      </p>
      <p>
        Only items marked with the ‘Subscribe & Save’ on product pages will
        qualify for Subscribe & Save benefits.
      </p>
      <p>
        <b>Termination</b>
      </p>
      <p>
        We may terminate your subscription at our discretion without notice. If
        we do so you will only be charged for orders that have been dispatched
        to you.
      </p>
    </ArticleContent>
  );
};
